import { ReactElement } from 'react'
import ModalDialogForm from 'ui/molecules/ModalDialogForm'
import ModalFooter from 'ui/molecules/ModalFooter'
import { FooterLinkModalProps } from './typing'

const FooterLinkModal = ({
  isOpen,
  setIsOpen,
  modalId,
  modalTitle,
  children,
  secureSiteFocusableRef
}: FooterLinkModalProps): ReactElement => {
  const closeModal = (): void => {
    setIsOpen(false)
    secureSiteFocusableRef?.current?.focus()
  }

  return (
    <ModalDialogForm
      modalId={modalId}
      modalTitle={modalTitle}
      onCloseModal={closeModal}
      isOpen={isOpen}
      footerOverride={
        <ModalFooter
          secondaryButtonText="Close"
          onSecondaryButtonClick={closeModal}
          showOnlySecondaryButton
        />
      }
      data-test="footer-form-modal"
    >
      {children}
    </ModalDialogForm>
  )
}

export default FooterLinkModal
